import { Language, Translations } from './types';
import { it } from './it';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';

export type { Language, Translations };
export { LANGUAGES } from './types';

const translations: Record<Language, Translations> = { it, en, es, fr, de };

export function getTranslations(lang: Language): Translations {
  return translations[lang] || translations.it;
}
